/* Scale each fixed canvas to the viewport.
 *
 * `transform: scale()` is purely visual — it leaves the element's layout box
 * at its authored size — so the wrapper's height has to be set to the SCALED
 * height or every band would reserve its full 1440-wide height and the page
 * would run metres long with huge gaps.
 *
 * Width is read from the wrapper (not window.innerWidth) so a scrollbar,
 * the theme editor's preview frame, or any padded container all stay honest.
 */
(function () {
  var MOBILE_MAX = 749;

  /* ?ddcforce=d|m pins one breakpoint's canvas regardless of viewport width.
     Reviewing the 1440 comp needs the desktop stage even in a narrow preview
     pane; without this the scaler and a CSS override fight each other and the
     wrapper ends up sized from the other breakpoint. Inert without the param. */
  var forced = (location.search.match(/[?&]ddcforce=(d|m)/) || [])[1] || '';
  if (forced) {
    document.documentElement.classList.add('ddc-force-' + forced);
  }

  function stageFor(cv) {
    var mobile = forced
      ? forced === 'm'
      : window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)').matches;
    return cv.querySelector(mobile ? '.ddc-cv__stage--m' : '.ddc-cv__stage--d');
  }

  function fit(cv) {
    var stage = stageFor(cv);
    if (!stage) { cv.style.height = ''; return; }

    var design = parseFloat(stage.getAttribute('data-cw'));
    var height = parseFloat(stage.getAttribute('data-ch'));
    if (!design || !height) return;

    var avail = cv.clientWidth || cv.getBoundingClientRect().width;
    if (!avail) return;

    var scale = avail / design;
    stage.style.setProperty('--ddc-s', scale);
    cv.style.height = (height * scale) + 'px';
  }

  function fitAll() {
    var list = document.querySelectorAll('.ddc-cv');
    for (var i = 0; i < list.length; i++) fit(list[i]);
  }

  fitAll();

  if (window.ResizeObserver) {
    var ro = new ResizeObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) fit(entries[i].target);
    });
    document.querySelectorAll('.ddc-cv').forEach(function (cv) { ro.observe(cv); });
  }
  window.addEventListener('resize', fitAll);
  window.addEventListener('orientationchange', fitAll);

  /* Web fonts can change nothing about geometry here (every box is fixed),
     but images decoding late can change clientWidth inside the editor. */
  window.addEventListener('load', fitAll);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);

  /* Shopify's theme editor swaps section markup in place. */
  document.addEventListener('shopify:section:load', fitAll);
  document.addEventListener('shopify:section:reorder', fitAll);
})();
